import { useAtomValue } from 'jotai';
import { hasRSimProductActiveFilterAtom } from 'atoms/filters/rsim-products';

export const useHasActiveFilters = () => {
  return useAtomValue(hasRSimProductActiveFilterAtom);
};
